
import $ from "jquery";
import { Component, Vue, Prop } from "vue-property-decorator";
import { es } from "vuejs-datepicker/dist/locale";
import moment from "moment";

@Component({
  components: {
    PhoneInput: () => import("@/components/Jobs/Profile/PhoneInput.vue")
  }
})
export default class ProfileInformation extends Vue {
  @Prop(Object) user!: any;
  @Prop(Object) phone!: any;
  @Prop(Object) secondphone!: any;
  @Prop(Boolean) notPhone!: boolean;
  @Prop(Function) writeNumber!: any;
  @Prop(Object) errorPhone!: any;
  @Prop(Boolean) userError!: any;
  type_value = [];
  levels = [];
  current = "";
  newImage = "";
  es = es;
  msjSlot = "Escribe una ubicacion";
  nacionalidad = [];
  errorMsgImg = false;
  optionsPlaces = [];

  async mounted() {
    const _this: any = this;
    _this.type_value = (
      await _this.$root._get("nucleus_types/TIPOS_DOC")
    ).data.map((item: any) => {
      return { ...item, label: item.description };
    });
    _this.levels = (
      await _this.$root._get("nucleus_types/NIVELES_EST")
    ).data.map((item: any) => {
      return { ...item, label: item.description };
    });

    if (_this.user.users_educations && _this.user.users_educations.length)
      _this.user.educationLevelId = _this.levels.find(
        (i: any) => i.id === _this.user.users_educations[0].study_level
      );

    if (_this.user.dni_type)
      _this.user.dni_type = _this.type_value.find(
        (i: any) => i.id === _this.user.dni_type
      );

    this.nacionalidad = (
      await (this as any).$root._get("nucleus_types/NACIONALIDADES")
    ).data.map((item: any) => {
      return { ...item, label: item.description };
    });

    if (
      (this as any).user.nucleus_user &&
      (this as any).user.nucleus_user.oi_localidad
    ) {
      await this.getLocation(
        (this as any).user.nucleus_user.oi_localidad,
        "external_id"
      );
      if (this.optionsPlaces.length) {
        (this as any).user.nucleus_user.oi_localidad = this.optionsPlaces[0];
      }
    }

    if ((this as any).user.nucleus_user.oi_nacionalidad) {
      (this as any).user.nucleus_user.oi_nacionalidad = (this as any).nacionalidad.find(
        (i: any) => {
          return (
            i.external_id === (this as any).user.nucleus_user.oi_nacionalidad
          );
        }
      );
    }
    if ((this as any).user.nucleus_user) {
      (this as any).$parent.phone.phone = (this as any).user.nucleus_user
        .te_celular
        ? (this as any).user.nucleus_user.te_celular
        : "";
      (this as any).$parent.phone.phonepais = (this as any).user.nucleus_user
        .c_pais_cel
        ? (this as any).user.nucleus_user.c_pais_cel
        : "";
      (this as any).$parent.phone.phonearea = (this as any).user.nucleus_user
        .c_area_cel
        ? (this as any).user.nucleus_user.c_area_cel
        : "";
      (this as any).$parent.secondphone.phone = (this as any).user.nucleus_user
        .te_nro
        ? (this as any).user.nucleus_user.te_nro
        : "";
      (this as any).$parent.secondphone.phonepais = (this as any).user
        .nucleus_user.c_pais
        ? (this as any).user.nucleus_user.c_pais
        : "";
      (this as any).$parent.secondphone.phonearea = (this as any).user
        .nucleus_user.c_area
        ? (this as any).user.nucleus_user.c_area
        : "";
    }
  }

  async getLocation(search: any, type: any) {
    let response = await (this as any).$root._get(
      `misc/locations?${type}=${search}`,
      {}
    );
    this.optionsPlaces = response;
  }

  triggerUpload() {
    $("#uploadImage").click();
  }

  customFormatter(date: any) {
    return moment(date).format("DD-MM-YYYY");
  }

  onFileChange(e: any) {
    var files = e.target.files || e.dataTransfer.files;
    if (!files.length) return;
    if (files[0].size > 1500000) {
      this.errorMsgImg = true;
      return;
    } else this.errorMsgImg = false;
    this.createImage(files[0]);
  }

  createImage(file: any) {
    var image = new Image();
    var reader = new FileReader();
    var vm = this;

    reader.onload = (e: any) => {
      vm.$emit("newImage", file);
      vm.newImage = e.target.result;
    };
    reader.readAsDataURL(file);
  }

  popEmail() {
    let i = (this as any).$root.error_bt.indexOf("email");
    if (i >= 0) {
      (this as any).$root.error_bt.splice(i, 1);
    }
    (this as any).$parent.userError = false;
  }

  async fetchOptions(search: any, loading: any) {
    if (search.length > 2) {
      loading(true);
      this.getLocation(search, "q");
      loading(false);
      if (this.optionsPlaces.length === 0) {
        (this as any).msjSlot = "Lo sentimos, no hay resultados.";
      }
    } else {
      this.msjSlot = "Escribe una ubicacion";
    }
  }

  handleSelect(event: any, type: any) {
    if (!event) {
      if (type === 'nacionality') {
        (this as any).user.nucleus_user.oi_nacionalidad = null;
      }
      else {
        (this as any).user.nucleus_user.oi_localidad = null;
      }
    }
  }
}
